import React from 'react'
import './Gesture.scss'

import SingleClick from './gestures/SingleClick.js'
import DoubleClick from './gestures/DoubleClick.js'


const Gesture = props => {
    const getGestureType = (str) => {
        console.log(`gesture type ${str} loaded`)
        if(str === 'single_click' || str === 'single-click'){
            return 'single-click'
        }
        if(str === 'double_click' || str === 'double-click'){
            return 'double-click'
        }

        return 'gesture-undefined'
    }

    const getGestureComponent = (type) => {
        if(type === 'gesture-undefined') return <></>
        if(type === 'single-click'){
            return <SingleClick 
                position={props.data.position}
                {...props}
                />
        }
        if(type === 'double-click'){
            return <DoubleClick 
                position={props.data.position}
                {...props}
                />
        }
    }

    const type = getGestureType(props.data.gestureType);

    return (
        <div className={`Gesture ${type}`}>
            {getGestureComponent(type)}
        </div>
    )
}

export default Gesture